import LocationDelete from './LocationDelete'
export {LocationDelete}
export default LocationDelete
